import { useState } from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import ModalService from "src/modals"
import { joinLobby } from "src/store/lobby"

import Modal from "src/components/modals/Modal"
import { apiErrorLines } from "src/utils/apiErrors"

const JoinLobbyModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [errors, setErrors] = useState([])
  const [formData, setFormData] = useState({
    number: "",
    password: "",
  })
  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(
      joinLobby({
        number: formData.number,
        password: formData.password || null,
      })
    )
      .unwrap()
      .then(() => ModalService.hideAll())
      .catch(setErrors)
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  return (
    <Modal>
      <h1>{t("lobbyModals.joinTitle")}</h1>
      {apiErrorLines(errors).map(({ key, text }) => (
        <p key={key} className="errored-text">
          <br />
          {text}
        </p>
      ))}
      <br />
      <br />
      <form onSubmit={handleSubmit}>
        <label htmlFor="number">{t("lobbyModals.numberLabel")}</label>
        <input
          type="number"
          id="number"
          name="number"
          className="form-input"
          placeholder={t("lobbyModals.numberPlaceholder")}
          value={formData.number}
          onChange={handleInputChange}
          required
          min="0"
        />

        <label htmlFor="password">{t("lobbyModals.passwordLabel")}</label>
        <input
          type="password"
          id="password"
          name="password"
          className="form-input"
          placeholder={t("lobbyModals.joinPasswordPlaceholder")}
          value={formData.password}
          onChange={handleInputChange}
        />

        <br />
        <br />
        <button type="submit">{t("lobbyModals.joinButton")}</button>
      </form>
    </Modal>
  )
}

export default JoinLobbyModal
